import { React } from "react";
import { Card, Typography } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { Button } from "../../../components";

import HeaderImg from "../../../assets/basketballHeader.JPG";
import SubHeaderImg from "../../../assets/subHeader.jpg";
import Signal from "../../../assets/signal.png";


const { Title } = Typography;

const Header = () => (
  <Card style={{ borderRadius: 20 }}>
    <div>
      <img src={HeaderImg} />
    </div>
    <div className="p-2 lg:p-6 block lg:flex justify-between items-end">
      <div className="flex">
        <div
          className="w-20 h-20 lg:w-40 lg:h-40 rounded-full block lg:flex overflow-hidden mr-5 forumHeader"
        >
          <img src={SubHeaderImg} className="w-full" />
        </div>
        <div>
          <Title level={3}>Basketball</Title>
          <div className="flex lg:flex items-center justify-between mt-2">
            <img src={Signal} />
            <p className="inline">42 Members</p>
          </div>
        </div>
      </div>
      <div className="flex justify-end forumHeaderBtn mt-6 lg:mt-0">
        <Button
          type="primary"
          className="mt-0 primary-color forumBtnActive"
          title="Join Forum"
          style={{
            height: "50px",
            borderRadius: "30px",
            paddingLeft: "2.5em",
            paddingRight: "2.5em",
          }}
        />
        <div className="hidden 2xl:block">
          <EllipsisOutlined style={{ fontSize: "36px", color: "#000", marginLeft: 10 }} />
        </div>
      </div>
    </div>
  </Card>
);

export default Header;
